"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentLocationOn = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CurrentLocationOn = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "current-location-on", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "current-location-on", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M26 12.286c0 1.821-.565 3.52-1.54 4.954a1.598 1.598 0 0 1-.183.388L17.492 28.21c-.675 1.053-2.309 1.053-2.984 0L7.723 17.628a1.6 1.6 0 0 1-.182-.388A8.765 8.765 0 0 1 6 12.286C6 7.157 10.477 3 16 3s10 4.157 10 9.286ZM16 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z", fill: "#172344", fillRule: "evenodd" }) })) })));
};
exports.CurrentLocationOn = CurrentLocationOn;
